/* eslint-disable global-require */
module.exports = ['artmarketinsight.reports.m13'];
